module.exports = __webpack_public_path__ + "static/media/rm6.73685785.jpg";